module.exports = "/shared/img/horse-racing.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/horse-racing.png
// module id = 205
// module chunks = 13